import { ActionTree } from 'vuex';

import api from '@/api';
import { RootState, RootActions, ErrorMessages, EditableStatus } from '@/store/types';
import Region from '@/store/models/region';
import { RegionsState, RegionsActions, RegionsMutations } from './types';
import { enhanceErrorWithMessage } from '@/utils/errors';

export const actions: ActionTree<RegionsState, RootState> = {
  [RegionsActions.LOAD_EDITABLE]({ commit, dispatch }): Promise<void> {
    commit(RegionsMutations.SET_EDITABLE_STATUS, EditableStatus.Loading);

    return api.regions
      .list()
      .then((response) => response.data)
      .then((response) => {
        commit(
          RegionsMutations.SET_EDITABLE,
          response.map((item) => Region.fromJSON(item)),
        );
        commit(RegionsMutations.SET_EDITABLE_STATUS, EditableStatus.Loaded);
      })
      .catch((error) => {
        enhanceErrorWithMessage(error, ErrorMessages.DATA_LOAD_ERROR);

        commit(RegionsMutations.SET_EDITABLE_STATUS, EditableStatus.Failed);
        return dispatch(RootActions.ERROR, error, { root: true });
      });
  },

  [RegionsActions.UPDATE_EDITABLE]({ commit }, changes): Promise<void> {
    commit(RegionsMutations.UPDATE_EDITABLE, changes);
    return Promise.resolve();
  },

  [RegionsActions.SAVE_EDITABLE]({ state, commit, dispatch }): Promise<void> {
    // TODO: implement
    throw Error('Not implemented');
  },
};

export default actions;
